import { Icon, ILinkProps as FILinkProps, ILinkStyles, Link as FLink } from '@fluentui/react';
import { forwardRef, Ref } from 'react';

import { IComponent } from '../../models/components.models';
import { useThemeStyles } from '../../utils/hooks';
import { combineClassNames } from '../../utils/utils';
import { linkStylesDefault } from './Link.styles';
export interface ILinkProps extends Omit<FILinkProps, 'styles'>, IComponent<Partial<ILinkStyles>> {
  iconName?: string;
}

export const Link = forwardRef((props: ILinkProps, ref: Ref<HTMLDivElement>) => {
  const { iconName, className, styles, children, ..._fProps } = props;
  const fProps = {
    ..._fProps,
    styles: useThemeStyles<ILinkStyles>(linkStylesDefault, styles),
    className: combineClassNames(className, !children && 'no-children'),
  };
  return (
    <FLink {...fProps} ref={ref} data-test={props['data-test'] || 'link'}>
      {iconName && <Icon className="Link-icon" iconName={iconName} />}
      <span className="Link-text">{children}</span>
    </FLink>
  );
});
